module.exports = __webpack_public_path__ + "img/mosque-noimage.9d36ba1e.png";